import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { formConfig } from '../../config/formConfig';

const Sidebar = () => {
  const { primary, secondary, footer } = formConfig.navigation;

  const resolvePath = (item) => {
    const route = formConfig.site.routes.find(r => r.targetId === item.targetId && r.type === item.type);
    return route ? route.path : '/';
  };

  const NavItem = ({ item }) => (
    <NavLink
      to={resolvePath(item)}
      className={({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
          isActive
            ? 'bg-[var(--primary)] text-white shadow-lg shadow-blue-500/20'
            : 'text-[var(--textMuted)] hover:bg-[var(--surfaceAlt)] hover:text-[var(--text)]'
        }`
      }
    >
      <SafeIcon name={item.icon} className="text-xl" />
      <span className="font-semibold text-sm tracking-wide">{item.label}</span>
    </NavLink>
  );

  return (
    <aside className="w-[280px] h-screen bg-[var(--surface)] border-r border-[var(--border)] fixed left-0 top-0 overflow-hidden flex flex-col">
      <div className="p-8 flex items-center gap-4">
        <div className="w-12 h-12 rounded-2xl bg-white p-2 shadow-sm border border-[var(--border)] flex items-center justify-center">
          <img src={formConfig.app.branding.logo} alt="Logo" className="w-full h-full object-contain" />
        </div>
        <div>
          <h1 className="text-lg font-black text-[var(--text)] leading-none tracking-tighter">BPA</h1>
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--primary)]">Forms Hub</p>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 pb-8 flex flex-col gap-8">
        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-[var(--textMuted)] px-4 mb-4 opacity-50">Main Intake</p>
          <div className="flex flex-col gap-1">
            {primary.items.map(item => <NavItem key={item.id} item={item} />)}
          </div>
        </div>

        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-[var(--textMuted)] px-4 mb-4 opacity-50">Resources</p>
          <div className="flex flex-col gap-1">
            {secondary.items.map(item => <NavItem key={item.id} item={item} />)}
          </div>
        </div>
      </nav>

      <div className="p-4 mt-auto border-t border-[var(--border)] bg-[var(--surfaceAlt)]/50">
        <div className="flex flex-wrap gap-x-4 gap-y-2 px-2">
          {footer.items.map(item => (
            <NavLink
              key={item.id}
              to={resolvePath(item)}
              className="text-[11px] font-bold text-[var(--textMuted)] hover:text-[var(--primary)] transition-colors"
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;